import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { driver } from "driver.js";
import { GuiService } from 'src/app/services/gui.service';
import { ActivatedRoute } from '@angular/router';
import { RestService } from 'src/app/services/rest.service';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { MealDisclaimerComponent } from './meal-disclaimer/meal-disclaimer.component';
import { RecipeInfoComponent } from './recipe-info/recipe-info.component';
import { MealInfoComponent } from './meal-info/meal-info.component';
import { MeasurementsComponent } from './meal-info/measurements/measurements.component';
import { SupportComponent } from '../../support/support.component';

@Component({
  selector: 'vex-meal-plan',
  templateUrl: './meal-plan.component.html',
  styleUrls: ['./meal-plan.component.scss']
})
export class MealPlanComponent implements OnInit {
  surveyId: string;
  activeTab: string = 'Meals';
  diet;
  environmentNode = environment.baseURL.node;
  recipePlaceholder = Array(2);
  recipes = {
    monday: [],
    tuesday: [],
    wednesday: [],
    thursday: [],
    friday: [],
    saturday: [],
    sunday: []
  };
  nutritionists: any = {
    "chiara@itsdesifit.com": {
      "fullName": "Dott.ssa Chiara Di Lullo",
      "instagram": "nutrizionista_chiaradiiullo",
      "jobTitle": "Biologa Nutrizionista",
      "img": "nutritionist_badges/chiara_di_lullo.jpeg"
    },
    "elena@itsdesifit.com": {
      "fullName": "Dott.ssa Elena Cucchiara",
      "instagram": "crunchandnutella_nutrizione",
      "jobTitle": "Biologa Nutrizionista",
      "img": "nutritionist_badges/elena_cucchiara.jpg"
    },
    "nutrizione@itsdesifit.com": {
      "fullName": "Dott.ssa Valentina Fantauzzi",
      "instagram": "nutrizionista_vf",
      "jobTitle": "Biologa Nutrizionista",
      "img": "nutritionist_badges/valentina_fantauzzi.jpg"
    },
  }

  constructor(public guiService: GuiService, private activatedRoute: ActivatedRoute, private dialog: MatDialog, private restService: RestService, public translate: TranslateService) { }

  ngOnInit() {
    this.guiService.showSpinner = false;
    this.activatedRoute.queryParams.subscribe(params => {
      if (params['dietId']) {
        this.surveyId = params['dietId'];
      }
    });
    if (this.surveyId && this.guiService.userLogged) {
      this.getDiet(this.surveyId);
    } else {
      this.guiService.goTo('main/home');
    }
  }

  splitRecipes() {
    this.recipes = {
      monday: [],
      tuesday: [],
      wednesday: [],
      thursday: [],
      friday: [],
      saturday: [],
      sunday: []
    };
    const keys = Object.keys(this.recipes);

    this.diet.recipes.colazione.forEach((element, i) => {
      const day = keys[i];
      if (day) {
        this.recipes[day].push(element);
      }
    });

    this.diet.recipes.pranzo.forEach((element, i) => {
      const day = keys[i];
      if (day) {
        this.recipes[day].push(element);
      }
    });

    this.diet.recipes.cena.forEach((element, i) => {
      const day = keys[i];
      if (day) {
        this.recipes[day].push(element);
      }
    });

    this.diet.recipes.spuntini.forEach((element, i) => {
      const day = keys[i];
      if (day) {
        this.recipes[day].push(element);
      }
    });

    console.debug('prova', this.recipes)
  }

  selectTab(tab: string) {
    this.activeTab = tab;

    if (!localStorage.getItem('tourMealInfosShowed') && this.activeTab === 'Infos') {
      setTimeout(() => {
        this.startTourInfos();
      }, 800);
    }
  }

  openModalDisclaimer(): void {
    const dialogRef = this.dialog.open(MealDisclaimerComponent, {
      disableClose: true,
      width: '100vw',
      height: '100vh',
      maxWidth: '100vw',
      autoFocus: false,
      panelClass: 'full-screen-dialog',
    });

    // Se vuoi gestire un eventuale ritorno di dati dalla dialog:
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        console.log('Dati ricevuti dal dialog:', result);
        // Puoi gestire il risultato qui, se necessario
      }
    });
  }


  getDiet(surveyId: string) {
    this.restService.postService('node', '/get-user-diet', { surveyId: surveyId, userId: this.guiService.userLogged.user.id }).subscribe((ris => {
      console.debug(ris)
      this.diet = ris;
      this.splitRecipes();

      setTimeout(() => {
        localStorage.getItem('tourMealShowed') ? null : this.startTour();
      }, 1000);
    }))
  }

  openModalRecipeInfo(recipe: any): void {
    const dialogRef = this.dialog.open(RecipeInfoComponent, {
      data: { data: recipe }, // equivalente di componentProps
      disableClose: true,
      width: '100vw',
      height: '100vh',
      maxWidth: '100vw',
      autoFocus: false,
      panelClass: 'full-screen-dialog',
    });

    // Se vuoi gestire i dati restituiti dalla modale
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log('Dati ricevuti dal dialog:', result);
      }
    });
  }


  openModalMealInfo(infos: any): void {
    const dialogRef = this.dialog.open(MealInfoComponent, {
      data: { data: infos }, // Passaggio dati (equivalente a componentProps)
      disableClose: true,
      width: '100vw',
      height: '100vh',
      maxWidth: '100vw',
      autoFocus: false,
      panelClass: 'full-screen-dialog',
    });

    // Gestione chiusura della modale
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log('Dati ricevuti dal dialog:', result);
      }
    });
  }


  openModalMeasurements(): void {
    const dialogRef = this.dialog.open(MeasurementsComponent, {
      disableClose: true,
      width: '100vw',
      height: '100vh',
      maxWidth: '100vw',
      autoFocus: false,
      panelClass: 'full-screen-dialog',
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log('Dati ricevuti dal dialog:', result);
        // eventuale logica post-chiusura
      }
    });
  }


  openModalSupport(): void {
    const dialogRef = this.dialog.open(SupportComponent, {
      disableClose: true,
      width: '100vw',
      height: '100vh',
      maxWidth: '100vw',
      autoFocus: false,
      panelClass: 'full-screen-dialog',
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log('Dati ricevuti dal dialog:', result);
        // eventuale logica post-chiusura
      }
    });
  }


  startTour(): void {
    localStorage.setItem('tourMealShowed', 'true');

    const driverObj = driver({
      showProgress: true,
      allowClose: true,
      steps: [
        { element: '.read-care', popover: { title: this.translate.instant('TUTORIALS.meal-plan.beforeYouStartTitle'), description: this.translate.instant('TUTORIALS.meal-plan.beforeYouStartDescription'), side: 'bottom' } },
        { element: '.tabs', popover: { title: this.translate.instant('TUTORIALS.meal-plan.chooseWhatToViewTitle'), description: this.translate.instant('TUTORIALS.meal-plan.chooseWhatToViewDescription'), side: 'bottom' } },
        { element: '.recipes-swiper', popover: { title: this.translate.instant('TUTORIALS.meal-plan.scrollDailyMealsTitle'), description: this.translate.instant('TUTORIALS.meal-plan.scrollDailyMealsDescription') } },
        { element: '.slide-tutorial-meal', popover: { title: this.translate.instant('TUTORIALS.meal-plan.viewRecipeTitle'), description: this.translate.instant('TUTORIALS.meal-plan.viewRecipeDescription') } },
        { element: '.icon-dish-compose', popover: { title: this.translate.instant('TUTORIALS.meal-plan.viewMealCompositionTitle'), description: this.translate.instant('TUTORIALS.meal-plan.viewMealCompositionDescription') } },
        { element: '.icon-support', popover: { title: this.translate.instant('TUTORIALS.meal-plan.accessSupportFormTitle'), description: this.translate.instant('TUTORIALS.meal-plan.accessSupportFormDescription') } }
      ]
    });

    driverObj.drive();
  }

  startTourInfos(): void {
    localStorage.setItem('tourMealInfosShowed', 'true');

    const driverObj = driver({
      showProgress: true,
      allowClose: true,
      steps: [
        { element: '.nutritionist-infos', popover: { title: this.translate.instant('TUTORIALS.meal-plan.discoverNutritionistTitle'), description: this.translate.instant('TUTORIALS.meal-plan.discoverNutritionistDescription'), side: 'bottom' } },
        { element: '.nutri-goal', popover: { title: this.translate.instant('TUTORIALS.meal-plan.viewNutritionGoalTitle'), description: this.translate.instant('TUTORIALS.meal-plan.viewNutritionGoalDescription'), side: 'bottom' } },
        { element: '.composi', popover: { title: this.translate.instant('TUTORIALS.meal-plan.viewMacronutrientsTitle'), description: this.translate.instant('TUTORIALS.meal-plan.viewMacronutrientsDescription') } },
        { element: '.meas-tutorial', popover: { title: this.translate.instant('TUTORIALS.meal-plan.reviewMeasurementsTitle'), description: this.translate.instant('TUTORIALS.meal-plan.reviewMeasurementsDescription') } }
      ],
      stagePadding: 1
    });

    driverObj.drive();
  }
}

